
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.988 1c3.994 0 7.306 3.4 7.33 7.575 0 2.525-1.218 4.725-2.922 6v1.875c0 .525-.438.95-.95 1L8.75 18h-.097a.986.986 0 0 1-.682-.275c-.195-.175-.365-.45-.365-.725v-2.45c-1.948-1.375-2.923-3.425-2.923-5.975C4.682 4.4 7.994 1 11.988 1Zm0 2C9.04 3 6.63 5.5 6.655 8.575c0 2.05.778 3.55 2.459 4.55.292.2.438.525.438.875v1.925l4.871-.4V14c0-.35.17-.7.487-.875 1.534-.85 2.41-2.55 2.435-4.55C17.345 5.5 14.935 3 11.988 3Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m15.373 20.65-6.649.5h-.073c-.511 0-.925-.4-.974-.925a.997.997 0 0 1 .901-1.075l6.649-.5a.96.96 0 0 1 1.047.925.997.997 0 0 1-.901 1.075ZM13.254 23.8l-2.386.2h-.074c-.511 0-.925-.4-.974-.925A.997.997 0 0 1 10.721 22l2.411-.2a.968.968 0 0 1 1.023.925.997.997 0 0 1-.9 1.075ZM15.86 8.55c-.049.45-.414.8-.852.8h-.073a.863.863 0 0 1-.755-.95c.146-1.425-1.072-1.95-1.218-2a.91.91 0 0 1-.511-1.125c.146-.45.633-.7 1.071-.525.901.325 2.557 1.55 2.338 3.8Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M11.9875 1C15.9815 1 19.2943 4.40019 19.3186 8.5752C19.3185 11.1001 18.1004 13.3002 16.3958 14.5752V16.4502C16.3956 16.975 15.9577 17.4 15.4465 17.4502L8.74927 18H8.65161C8.40808 18 8.14044 17.8996 7.96997 17.7246C7.77514 17.5496 7.60474 17.275 7.60474 17V14.5498C5.65652 13.1748 4.68193 11.1251 4.68188 8.5752C4.68188 4.40031 7.99375 1.00019 11.9875 1ZM11.9875 3C9.04082 3.00003 6.63019 5.50022 6.65454 8.5752C6.6546 10.625 7.43339 12.125 9.11353 13.125C9.40577 13.325 9.552 13.65 9.552 14V15.9248L14.4231 15.5254V14C14.4231 13.65 14.5938 13.3 14.9104 13.125C16.4444 12.275 17.3206 10.575 17.345 8.5752C17.345 5.50019 14.9343 3 11.9875 3Z\" fill=\"#000000\"/>\r\n<path d=\"M15.3727 20.6501L8.72419 21.1501H8.65113C8.13971 21.1501 7.7257 20.7501 7.67699 20.2251C7.62829 19.6751 8.04229 19.2001 8.57807 19.1501L15.2265 18.6501C15.7867 18.6001 16.2494 19.0251 16.2737 19.5751C16.3224 20.1251 15.9084 20.6001 15.3727 20.6501Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M13.2541 23.7999L10.8675 23.9999H10.7944C10.283 23.9999 9.86901 23.5999 9.8203 23.0749C9.7716 22.5249 10.1856 22.0499 10.7214 21.9999L13.1324 21.7999C13.6681 21.7749 14.1308 22.1749 14.1552 22.7249C14.2039 23.2749 13.7899 23.7499 13.2541 23.7999Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M15.8601 8.54998C15.8114 8.99998 15.4461 9.34998 15.0077 9.34998H14.9346C14.4719 9.29998 14.131 8.87498 14.1797 8.39998C14.3258 6.97498 13.1081 6.44998 12.962 6.39998C12.5237 6.22498 12.3045 5.72498 12.4506 5.27497C12.5967 4.82497 13.0838 4.57497 13.5221 4.74997C14.4232 5.07497 16.0792 6.29998 15.8601 8.54998Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light.2abc84bf763b1b2e870e6eaefd99ebf7.svg"),
        {
          React: SvgLight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      